import taibahValley from "../../../design/source-assets/taibah-valley-registered-primary.svg";
import taibahValleyWhite from "../../../design/source-assets/taibah-valley-registered-white.svg";
import { useLocale } from "./localization";

export type PartnerSignaturePlacement =
  "hero" | "sidebar" | "mobile" | "footer";

export function PartnerSignature({
  placement,
}: {
  readonly placement: PartnerSignaturePlacement;
}) {
  const { t } = useLocale();

  return (
    <div
      className={`partner-signature partner-signature--${placement}`}
      role="img"
      aria-label={t("brand.partnerSignature")}
    >
      <span aria-hidden="true">{t("brand.partnerCredit")}</span>
      <span className="partner-signature__logo" aria-hidden="true">
        <img
          className="partner-signature__light"
          src={taibahValley}
          alt=""
          width="840"
          height="392"
        />
        <img
          className="partner-signature__dark"
          src={taibahValleyWhite}
          alt=""
          width="840"
          height="392"
        />
      </span>
    </div>
  );
}
